import { ShieldCheck } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Confianca = () => {
  return (
    <section data-testid="confianca-section" className="bg-white py-16 md:py-20 border-t border-maternnia-nevoa/60">
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="h-12 w-12 mx-auto rounded-2xl bg-maternnia-porcelana flex items-center justify-center mb-6">
            <ShieldCheck size={24} className="text-maternnia-eucalipto" />
          </div>
          <h2 className="font-serif text-3xl md:text-4xl tracking-tight text-maternnia-charcoal font-medium">
            Informação com cuidado e responsabilidade.
          </h2>
          <p className="mt-5 text-sm md:text-base text-maternnia-taupe leading-relaxed font-light">
            Os conteúdos da Maternnia têm caráter educativo e não substituem consulta, diagnóstico ou acompanhamento individual com profissionais de saúde.
          </p>
          <Link
            to="/politica-editorial"
            data-testid="politica-editorial-link"
            className="inline-block mt-6 text-sm font-medium text-maternnia-eucalipto hover:text-maternnia-floresta underline underline-offset-4 transition-colors"
          >
            Política editorial
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default Confianca;
